import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

const ROW_BASE = 'tw:flex tw:items-center tw:gap-3 tw:px-3 tw:py-2 tw:cursor-pointer '
  + 'tw:text-sm tw:bg-transparent tw:border-0 tw:w-full tw:text-left '
  + 'tw:hover:bg-gray-100'

const ROW_SELECTED = 'tw:bg-[#effff6]! tw:text-gray-700'

const ROW_ACCENT = 'tw:text-ds-primary tw:font-medium'

const ROW_DISABLED = 'tw:opacity-50 tw:cursor-not-allowed tw:hover:bg-transparent'

const CHECKBOX_BASE = 'tw:flex tw:items-center tw:justify-center tw:shrink-0 tw:w-4 tw:h-4 '
  + 'tw:rounded! tw:border tw:border-solid tw:text-[10px] tw:text-white'

const CHECKBOX_CHECKED = 'tw:bg-ds-primary tw:border-ds-primary'

const CHECKBOX_UNCHECKED = 'tw:bg-gray-50 tw:border-gray-300'

const resolveStateClass = ({ isChecked, isDisabled, accent }) => {
  if (accent)
    return ROW_ACCENT
  if (isDisabled)
    return ROW_DISABLED
  if (isChecked)
    return ROW_SELECTED
  return ''
}

const OptionRow = ({ option, isChecked, isDisabled, accent, onToggle }) => {
  const handleClick = useCallback(() => {
    if (isDisabled)
      return
    onToggle(option.value)
  }, [onToggle, option.value, isDisabled])

  const stateClass = resolveStateClass({ isChecked, isDisabled, accent })
  const checkboxClass = `${CHECKBOX_BASE} ${isChecked ? CHECKBOX_CHECKED : CHECKBOX_UNCHECKED}`

  return (
    <button className={`${ROW_BASE} ${stateClass}`} disabled={isDisabled} type="button" onClick={handleClick}>
      <span className={checkboxClass}>
        {isChecked ? <i className="fas fa-check" /> : null}
      </span>
      <span>{option.label}</span>
    </button>
  )
}

OptionRow.propTypes = {
  accent: PropTypes.bool,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired
}

OptionRow.defaultProps = {
  accent: false
}

export default OptionRow
